import './xmas-mountain.css';

export function XmasMountain({ mountain1, mountain2 }: { mountain1?: boolean; mountain2?: boolean }) {
  return (
    <>
      {mountain1 && (
        <section className='hidden sm:block absolute absolute bottom-0 left-1/5 scale-[0.411] origin-bottom-left'>
          <div className='mountain-one'>
            <div className='mountain-top1'>
              <div className='mountain-cap1'></div>
            </div>
          </div>
          <div className='mountain-two'>
            <div className='mountain-top2'>
              <div className='mountain-cap2'></div>
            </div>
          </div>
          <div className='mountain-three'>
            <div className='mountain-top3'>
              <div className='mountain-cap3'></div>
            </div>
          </div>
        </section>
      )}
      {/* scale ben trai: 'absolute bottom-0 left-0 scale-[0.33] origin-bottom-left */}
      {/* scale ben phai: 'absolute bottom-0 left-1/2 -translate-x-1/2 scale-50 origin-bottom */}
      {mountain2 && (
        <section className='hidden sm:block absolute absolute bottom-0 left-2/3 -translate-x-1/2 scale-[0.296] scale-[0.22] sm:scale-[0.296] origin-bottom'>
          <div className='mt1'>
            <div className='mtsnow1'></div>
            <div className='snow-peak-1a'></div>
            <div className='snow-peak-1b'></div>
          </div>
          <div className='mt2'>
            <div className='snow2'></div>
            <div className='snow-peak-2a'></div>
            <div className='snow-peak-2b'></div>
            <div className='snow-peak-2c'></div>
          </div>
          <div className='mt3'>
            <div className='snow3'></div>
            <div className='snow-peak-3a'></div>
            <div className='snow-peak-3b'></div>
            <div className='snow-peak-3c'></div>
            <div className='snow-peak-3d'></div>
          </div>
          <div className='mt4'>
            <div className='snow4'></div>
            <div className='snow-peak-4a'></div>
            <div className='snow-peak-4b'></div>
          </div>
          <div className='mt5'>
            <div className='snow5'></div>
            <div className='snow-peak-5a'></div>
            <div className='snow-peak-5b'></div>
            <div className='snow-peak-5c'></div>
          </div>
          <div className='mt6'>
            <div className='snow6'></div>
            <div className='snow-peak-6a'></div>
            <div className='snow-peak-6b'></div>
            <div className='snow-peak-6c'></div>
            <div className='snow-peak-6d'></div>
          </div>
        </section>
      )}
    </>
  );
}
